import { render } from "./Lead_Contacts.vue?vue&type=template&id=9949cf44"
import script from "./Lead_Contacts.vue?vue&type=script&lang=js"
export * from "./Lead_Contacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__